import { render } from "./SolicistacoesList.vue?vue&type=template&id=544cd7d1"
import script from "./SolicistacoesList.vue?vue&type=script&lang=js"
export * from "./SolicistacoesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__